import { IconProps } from "./icon.type";

export function IcFlagAr({ ...props }: IconProps) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      {...props}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1858_37870)">
        <path
          d="M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16Z"
          fill="#6DA544"
        />
        <path
          d="M4.52173 9.56543C4.52173 10.1417 4.98892 10.6089 5.5652 10.6089H8.69563C8.69563 11.0891 9.08495 11.4785 9.5652 11.4785H10.6087C11.0889 11.4785 11.4782 11.0891 11.4782 10.6089V9.56543H4.52173Z"
          fill="#F0F0F0"
        />
        <path
          d="M11.5653 4.52197V6.95675C11.5653 7.34035 11.2532 7.65241 10.8696 7.65241V8.69588C11.8286 8.69588 12.6088 7.91569 12.6088 6.95675V4.52197H11.5653Z"
          fill="#F0F0F0"
        />
        <path
          d="M4.08701 6.95675C4.08701 7.34035 3.77495 7.65241 3.39136 7.65241V8.69588C4.35033 8.69588 5.13048 7.91569 5.13048 6.95675V4.52197H4.08701V6.95675Z"
          fill="#F0F0F0"
        />
        <path d="M10 4.52197H11.0435V6.95675H10V4.52197Z" fill="#F0F0F0" />
        <path
          d="M8.43469 5.9128C8.43469 6.0087 8.35666 6.0867 8.26079 6.0867C8.16491 6.0867 8.08688 6.00867 8.08688 5.9128V4.52148H7.04341V5.9128C7.04341 6.0087 6.96538 6.0867 6.86951 6.0867C6.77363 6.0867 6.6956 6.00867 6.6956 5.9128V4.52148H5.6521V5.9128C5.6521 6.58408 6.19822 7.1302 6.86951 7.1302C7.12804 7.1302 7.36779 7.04895 7.56516 6.91095C7.76251 7.04892 8.00229 7.1302 8.26082 7.1302C8.31288 7.1302 8.36407 7.12655 8.41441 7.12014C8.34048 7.4248 8.0661 7.65192 7.73907 7.65192V8.69539C8.69804 8.69539 9.47819 7.9152 9.47819 6.95627V5.9128V4.52148H8.43472V5.9128H8.43469Z"
          fill="#F0F0F0"
        />
        <path d="M5.6521 7.65234H7.21732V8.69581H5.6521V7.65234Z" fill="#F0F0F0" />
      </g>
      <defs>
        <clipPath id="clip0_1858_37870">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
